import { useAtom } from "jotai";

import { useResponsive } from "shared/hooks";
import { registerEmailCookieAtom, useRegisterEmailExpirationEffect } from "shared/lib/account";
import { theme } from "shared/lib/styles";

import { AccountActivation } from ".";

export const useAccountActivation = () => {
  const isDesktopUp = useResponsive(theme.breakpoints.up("desktop"), false);
  const [{ registerEmail }, updateRegisterEmailCookie] = useAtom(registerEmailCookieAtom);

  useRegisterEmailExpirationEffect();

  if (!registerEmail || !isDesktopUp) return;
  return (
    <AccountActivation email={registerEmail} onClose={() => updateRegisterEmailCookie(null)} />
  );
};
